import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import Topbar from "./Topbar";
import RoleBottomNav from "@/components/feature/panel/RoleBottomNav";
import { AiCoachProvider } from "@/components/feature/ai-coach/AiCoachProvider";
import AiCoach from "@/components/feature/ai-coach/AiCoach";
import { studentMenu, studentBottomNav } from "@/data/panels";

export default function StudentLayout() {
  return (
    <AiCoachProvider>
      <div className="dx-panel-theme min-h-screen bg-background-100">
        <Sidebar />
        <div className="lg:pl-64">
          <Topbar />
          <main className="p-4 md:p-6 lg:p-8 pb-safe-nav">
            <Outlet />
          </main>
        </div>
        <RoleBottomNav
          menu={studentMenu}
          bottomNav={studentBottomNav}
          homePath="/ogrenci"
          roleLabel="Öğrenci"
        />
      </div>
      <AiCoach />
    </AiCoachProvider>
  );
}